import React from 'react';
import Logo from '../Logo';
import { Link, useIdioma } from '../../i18n';

/**
 * O painel da foto das telas de acesso (NewLogin.css): a marca, a armadilha
 * fotográfica e a legenda, que cada tela preenche e que termina sempre no
 * crédito. No telefone o painel sai inteiro, e cada tela mostra a marca no
 * alto do formulário.
 *
 * A foto vem por URL de /marca, nunca por import: o pré-render embutiria a
 * imagem importada em base64.
 */
const FotoDaEntrada = ({ children }) => {
  const { t } = useIdioma();

  return (
    <figure className="entrada-foto">
      <Link to="/" className="entrada-marca">
        <Logo size={28} />
      </Link>
      <img
        src="/marca/puma-armadilha-fotografica.jpg"
        width="1280"
        height="867"
        loading="lazy"
        alt={t('entrada.fotoAlt')}
      />
      <figcaption>
        {children}
        <span className="entrada-credito">{t('entrada.fotoCredito')}</span>
      </figcaption>
    </figure>
  );
};

export default FotoDaEntrada;
